import React, { useState, useEffect } from "react";
import { Button, Col, Form, InputGroup, NavLink, Row } from "react-bootstrap";
import view from "../../../assets/images/icons/view.png";
import hidden from "../../../assets/images/icons/hidden.png";
import * as Yup from "yup";
import { useNavigate, Link } from "react-router-dom";
import { getFollowersCoach, userUpdate } from "../../../utils/api";
import { Formik } from "formik";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";
import Pic from "../../../assets/images/icons/user.png";
import blog_card_img1 from "../../../assets/images/dummy/blog_card_img1.png";

const UserMyCoachComponent = () => {
  const [coachList, setCoachData] = useState([]);

  useEffect(() => {
    getCoachList();
  }, []);

  const getCoachList = async () => {
    try {
      const coachData = await getFollowersCoach();
      console.log("090", coachData);
      setCoachData(coachData?.data?.data || []);
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
  };
  console.log("coachList", coachList);
  const defaultUserImage = (e) => {
    e.target.src = blog_card_img1;
  };
  //
  return (
    <>
      <section className="p-5 bg-body-tertiary">
        <div className="text-start hdng_a">
          <h2 className="mb-4">Coach List</h2>
        </div>
        <div className="">
          {coachList.length > 0 ? (
            coachList.map((coach, index) => (
              <>
                <div
                  key={index}
                  className="px-4 py-3 mt-2 mb-3 bg-white border rounded-xl position-relative d-flex align-items-center user-info justify-content-between"
                >
                  <div>
                    <div className="mb-2 position-relative d-flex align-items-center user-info">
                      <img
                        className="w-[2.8rem] h-[2.8rem] mr-3 rounded-full object-cover"
                        alt="user pic"
                        src={
                          coach.profile_pic
                            ? `${process.env.REACT_APP_COACH_PROFILE_FOLDER_PATH}${coach.profile_pic}`
                            : Pic
                        }
                      />
                      <div className="user-name lh-1">
                        <Link
                          to={`/browse-coach/coach-details/${coach.id}`}
                          style={{ textDecoration: "none", color: "inherit" }}
                        >
                          <span className="fs-18 fw-600">{coach.name}</span>
                        </Link>
                        <div className="mt-1 d-flex">
                          <small className="overflow-hidden fs-14 me-1 d-inline-block">
                            {coach.tags}
                          </small>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <span className="fs-12 me-1">Coach Program:</span>
                      <b className="primary-text-color">
                        {coach.total_programs} Session Program
                      </b>
                    </div>
                  </div>
                  <div className="text-center">
                    <div className="">
                      {/* <div class="progress-bar" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div> */}
                    </div>
                    <Link to={`/browse-coach/coach-details/${coach.id}`}>
                      <button className="px-5 mt-2 btn btn-warning fs-12">
                        Book Now
                      </button>
                    </Link>
                  </div>
                </div>
              </>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-center">
                No Data Found
              </td>
            </tr>
          )}
        </div>
      </section>
    </>
  );
};

export default UserMyCoachComponent;
